import { useRef, useEffect, lazy, Suspense, useState } from "react";
import "./customized-text-editor.css";
import "react-quill/dist/quill.snow.css";
import katex from "katex";
import "katex/dist/katex.css";
import { modules, formats } from "./CustomizedToolbar";

window.katex = katex;

// Lazy-load ReactQuill to avoid StrictMode/findDOMNode issues
const ReactQuill = lazy(() => import("react-quill"));

const CustomizedTextEditor = ({ options, content, setContent }) => {
  const quillRef = useRef(null);
  const [editorReady, setEditorReady] = useState(false);

  useEffect(() => {
    if (!quillRef.current) return;

    // Dynamically import mathquill4quill
    import("mathquill4quill").then((mathquill4quill) => {
      const enableMathQuill = mathquill4quill.default({
        Quill: quillRef.current.Quill,
        katex,
      });
      enableMathQuill(quillRef.current.getEditor(), options);
      setEditorReady(true);
    });
  }, [options]);

  return (
    <div className="editor-wrapper">
      <Suspense fallback={<p>Loading editor...</p>}>
        <ReactQuill
          ref={quillRef}
          theme="snow"
          value={content}
          onChange={setContent}
          modules={modules}
          formats={formats}
          placeholder="Type text here, or click formula button"
        />
      </Suspense>
      {!editorReady && (
        <p style={{ fontSize: "0.6rem", color: "grey" }}>
          Initializing formulas...
        </p>
      )}
    </div>
  );
};

export default CustomizedTextEditor;
